/**
 * DirectionsRenderer
 *
 * 還原自 index.pretty.js L686。這個元件不是 .vue SFC，而是由
 * vue2-google-maps 的 MapElementFactory 在執行期產生，
 * 因此不會出現在 normalizeComponent 的抽取結果中，需另外還原。
 *
 * 用途：在結帳頁的地圖上畫出店家到外送地址的路線，
 * 並把 Google Directions 的結果透過 update 事件回傳給父元件
 * （父元件據此計算外送時間與距離）。
 */

import { MapElementFactory } from 'vue2-google-maps'

export default MapElementFactory({
        name: "directionsRenderer",
        ctr: function () {
          return window.google.maps.DirectionsRenderer;
        },
        events: [],
        mappedProps: {},
        props: {
          origin: { type: [Object, Array] },
          destination: { type: [Object, Array] },
          travelMode: { type: String },
          routers: { type: [Object, Array] },
        },
        afterCreate: function (f) {
          var v = this,
            P = new window.google.maps.DirectionsService();
          this.$watch(
            function () {
              return [v.origin, v.destination, v.travelMode, v.routers];
            },
            function () {
              var e = v.origin,
                n = v.destination,
                z = v.travelMode,
                t = v.routers;
              if (null !== t) f.setDirections(t);
              else {
                if (null === e || null === n || null === z) return;
                P.route({ origin: e, destination: n, travelMode: z }, function (P, e) {
                  "OK" === e && (f.setDirections(P), v.$emit("update", P.routes));
                });
              }
            },
          );
        },
      })
